import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
var HideUntil = styled.div.withConfig({
  displayName: "Hide__HideUntil",
  componentId: "sc-pas0vk-0"
})(["display:none;", "{display:", ";}"], function (_ref) {
  var theme = _ref.theme,
      bp = _ref.bp;
  return theme.mediaQueries[bp];
}, function (_ref2) {
  var display = _ref2.display;
  return display;
});
HideUntil.propTypes = {
  bp: PropTypes.oneOf(['mobile', 'tablet', 'desktop', 'large']),
  display: PropTypes.string
};
HideUntil.defaultProps = {
  display: 'block'
};
var HideAfter = styled.div.withConfig({
  displayName: "Hide__HideAfter",
  componentId: "sc-pas0vk-1"
})(["", "{display:none;}display:", ";"], function (_ref3) {
  var theme = _ref3.theme,
      bp = _ref3.bp;
  return theme.mediaQueries[bp];
}, function (_ref4) {
  var display = _ref4.display;
  return display;
});
HideAfter.propTypes = HideUntil.propTypes;
HideAfter.defaultProps = HideUntil.defaultProps;

var Hide = function Hide() {
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};

Hide.Until = HideUntil;
Hide.After = HideAfter;
export default Hide;